import React, { useState, useEffect, useRef } from 'react'
import LocaleSelect from 'components/LocaleSelect'
import {FormattedMessage, useIntl} from "react-intl";
import messages from "./messages";
import Select from 'react-select'
import {runtime} from 'rest/runtime';
import { Button } from '@arnsbogroup/react-voicearchive'

const InlineEdit = ({ attr, value, onChange, type, disabled = false }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [inputValue, setInputValue] = useState(value)
  const inputRef = useRef(null)
  const [timezones, setTimezones] = useState([])

  useEffect(() => {
    fetch('/rest/v2/supplier/timezones')
      .then((response) => response.json())
      .then((data) => setTimezones(data.map((timezone) => ({label: timezone, value: timezone}))))
      .catch((err) => {
        toastr.error(err)
      })
  }, [])

  useEffect(() => {
    setInputValue(value)
  }, [value])

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus()
    }
  }, [isEditing])

  const onSave = () => {
    setIsEditing(false)
    onChange(inputValue)
  }

  const onEdit = () => {
    setIsEditing(true)
  }

  return (
    <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
      <dt className="text-sm font-medium text-gray-500">
        { attr }
      </dt>
      <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
        <span className="grow">
          { isEditing ? (
            type == 'text' ? (
                <input ref={inputRef} value={inputValue} onChange={({ target: { value } }) => setInputValue(value)} placeholder={attr} />
              ) : (
                <Select
                  value={timezones.find( timezone => timezone.value === inputValue )}
                  onChange={ (timezone) => setInputValue(timezone.value)}
                  placeholder={attr}
                  options={timezones}
                />
              )
          ) : (
            <span>{ value }</span>
          ) }
        </span>
        <span className="ml-4 shrink-0">
          { isEditing ? (
            <Button 
              variant="inline"
              size='sm'
              onClick={onSave}
            >
              <FormattedMessage {...messages.save}/>
            </Button>
          ) : (
            <Button 
              variant="inline"
              size='sm'
              onClick={onEdit} 
              disabled={disabled} 
            >
              <FormattedMessage {...messages.update}/>
            </Button>
          ) }
        </span>
      </dd>
    </div>
  )
}

const General = ({ onChange, ...props }) => {
  const { name, username, image, email, title, timezone } = props
  const { formatMessage } = useIntl()

  const onChangeImage = ({ target: { files } }) => {
    const image = new FormData()
    image.append('file', files[0])

    onChange({ ...props, image })
  }

  return (
    <React.Fragment>
      <div className="mt-10 divide-y divide-gray-200">
        <div className="space-y-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            <FormattedMessage {...messages.profile}/>
          </h3>
          <p className="max-w-2xl text-sm text-gray-500">
            <FormattedMessage {...messages.visibleInformation}/>
          </p>
        </div>
        <div className="mt-6">
          <dl className="divide-y divide-gray-200">
            <InlineEdit attr={formatMessage(messages.name)} disabled={runtime.currentUser.isSupplier()} value={name} onChange={(name) => onChange({ ...props, name })} type='text' />
            <InlineEdit attr={formatMessage(messages.username)} disabled={runtime.currentUser.isSupplier()} value={username} onChange={(username) => onChange({ ...props, username })} type='text' />
            <InlineEdit attr={formatMessage(messages.email)} disabled={runtime.currentUser.isSupplier()} value={email} onChange={(email) => onChange({ ...props, email })} type='text' />
            <InlineEdit attr={formatMessage(messages.jobTitle)} value={title} onChange={(title) => onChange({ ...props, title })} type='text' />


            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:pt-5">
              <dt className="text-sm font-medium text-gray-500">
                <FormattedMessage {...messages.photo}/>
              </dt>
              <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                <span className="grow">
                  { image ? (
                    <img className="h-8 w-8 rounded-full" src={image} alt="" />
                  ) : (
                    <div className="h-8 w-8 rounded-full bg-gray-100" />
                  ) }
                </span>
                <span className="ml-4 shrink-0 flex items-start space-x-4">
                  
                <Button
                  variant="inline"
                  size='sm'
                  title={formatMessage(messages.update)}
                  onClick={() => document.getElementById('image').click()}
                >
                  <FormattedMessage {...messages.update}/>
                </Button>

                  <input type="file" id="image" name="image" className="hidden" accept="image/x-png,image/jpeg" onChange={onChangeImage} />

                  { image &&
                    <React.Fragment>
                      <span className="text-gray-300 mt-2" aria-hidden="true">|</span>
                      <Button
                        variant="inline"
                        size='sm'
                        onClick={() => onChange({ ...props, image: null })}
                        title={formatMessage(messages.remove)}>
                        <FormattedMessage {...messages.remove}/>
                      </Button>
                    </React.Fragment>
                  }
                </span>
              </dd>
            </div>
          </dl>
        </div>
      </div>

      <div className="mt-10 divide-y divide-gray-200">
        <div className="space-y-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            <FormattedMessage {...messages.account}/>
          </h3>
          <p className="max-w-2xl text-sm text-gray-500">
            <FormattedMessage {...messages.manageInformation}/>
          </p>
        </div>
        <div className="mt-6">
          <dl className="divide-y divide-gray-200">
          <InlineEdit attr={formatMessage(messages.timezone)} value={timezone} onChange={(timezone) => onChange({ ...props, timezone })} type='select' />
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-medium text-gray-500">
                <FormattedMessage {...messages.language}/>
              </dt>
              <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                <LocaleSelect />
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </React.Fragment>
  )
}

export default General
